import React from 'react'
import Spinner from 'react-bootstrap/Spinner';

const Loader = () => {
  return (
  <div className='loader'>
      <Spinner animation="border" className='loader' role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>
  )
}

export default Loader